var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyApproved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.8335,
    cy: 9.68457,
    r: 9,
    stroke: "#20A74E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2898 5.93228C14.0893 5.7606 13.829 5.67576 13.5661 5.69641C13.3032 5.71705 13.0592 5.84149 12.8878 6.04237L8.60628 11.062L6.30292 9.1344C6.21173 9.05577 6.10586 8.99609 5.99147 8.95884C5.87707 8.92158 5.75643 8.9075 5.63655 8.91739C5.51668 8.92729 5.39996 8.96098 5.29319 9.01649C5.18641 9.07201 5.09171 9.14824 5.01459 9.24077C4.93747 9.3333 4.87946 9.44027 4.84394 9.55547C4.80842 9.67067 4.7961 9.7918 4.80769 9.91181C4.81928 10.0318 4.85456 10.1483 4.91146 10.2546C4.96837 10.3608 5.04577 10.4546 5.13916 10.5306L8.22513 13.1135C8.32029 13.1931 8.43076 13.2521 8.54967 13.287C8.66858 13.3218 8.79338 13.3318 8.91629 13.3162C9.04664 13.3061 9.17372 13.2703 9.29027 13.2109C9.40681 13.1515 9.51053 13.0697 9.59548 12.97L14.399 7.33726C14.5701 7.13616 14.6545 6.87523 14.6339 6.61175C14.6133 6.34826 14.4892 6.10374 14.289 5.93185",
    fill: "#20A74E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyApproved);
export default __webpack_public_path__ + "static/media/emptyApproved.332fd5065d2a31668a1091c9851f083e.svg";
export { ForwardRef as ReactComponent };